import React from 'react';

import { Modal, Button } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Container } from '../../../../../symphony';

import { SlDiscussContext } from '../../../global-constants';
import { SlActions } from '../../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../../global-interface';

import s from './DeleteQuestionModal.scss';

export function DeleteQuestionModal() {
	useStyles(s);
	const { actions$ } = Container.take(SlDiscussContext, SlActions);

	const handleClose = () => {
		actions$.next({
			type: ActionType.OnQuestionDeleteModalCloseClick,
			requestType: RequestType.Parallel,
		});
	};

	const handleDeleteClick = () => {
		actions$.next({
			type: ActionType.OnQuestionDeleteModalDeleteClick,
			requestType: RequestType.Parallel,
		});
	};

	return (
		<Modal.Custom
			onClose={handleClose}
			noPadding
			className="discuss-delete-question-modal"
		>
			<div className="discuss-delete-question-modal__wrapper">
				<h4 className="discuss-delete-question-modal__title">
					Are you sure?
				</h4>
				<p className="discuss-delete-question-modal__text">
					Your question and any replies will be permanently deleted.
				</p>
				<div className="discuss-delete-question-modal__buttons">
					<Button
						type="button"
						buttonType="secondary"
						size="m"
						onClick={handleClose}
					>
						Cancel
					</Button>
					<Button
						type="button"
						buttonType="danger"
						className="discuss-delete-question-modal__delete-btn"
						size="m"
						onClick={handleDeleteClick}
					>
						Delete
					</Button>
				</div>
			</div>
		</Modal.Custom>
	);
}
